import React from 'react';
import MDCSelect from './MDCSelect.js.jsx';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';
import classNames from 'classnames';

export default function LineItems({
  wrapperId,
  itemType,
  newButtonId,
  items,
  onAdd,
  onRemove,
  defaultAmount,
  selectLabel,
  selectOptions,
  selectDefaultValue,
  namePattern,
}) {
  const interpolate = (pattern, index, field) => {
    const p = pattern == null ? '' : String(pattern);
    return p
      .replace(/{{index}}/g, String(index))
      .replace(/{{field}}/g, String(field ?? ''));
  };

  const nameToId = (name) => {
    return String(name)
      .replace(/\]\[|\[|\]/g, '_')
      .replace(/^_+|_+$/g, '')
      .replace(/__+/g, '_');
  };

  const getDefault = (v, i, fallback) =>
    v == null ? fallback : typeof v === 'function' ? v(i) : v;

  return (
    <>
      <div id={wrapperId}>
        {items.map((_, index) => {
          const selectName = interpolate(namePattern, index, 'item_id');
          const selectId = nameToId(selectName);

          const descName = interpolate(namePattern, index, 'description');
          const descId = nameToId(descName);

          const qtyName = interpolate(namePattern, index, 'quantity');
          const qtyId = nameToId(qtyName);

          const amountName = interpolate(namePattern, index, 'amount');
          const amountId = nameToId(amountName);

          return (
            <div
              key={index}
              id={`${itemType}-${index}`}
              className={`pm-removable-row pm-margin-bottom-20 ${itemType}`}
            >
              <div className="pm-removable-row--body">
                <div className="pm-flex">
                  <div className="pm-flex pm-flex-grow pm-flex-4">
                    <div
                      className={classNames(
                        'pm-flex',
                        'pm-flex-col',
                        newLeaseModalStyles.noMarginBottom
                      )}
                    >
                      <MDCSelect
                        label={selectLabel}
                        name={selectName}
                        id={selectId}
                        options={selectOptions}
                        defaultValue={getDefault(selectDefaultValue, index, '')}
                      />
                    </div>

                    <div className="pm-flex pm-flex-col">
                      <div className="mdc-form-field mdc-form-field--align-end">
                        <div
                          className="mdc-text-field pm-large"
                          data-mdc-auto-init="MDCTextField"
                        >
                          <input
                            type="text"
                            className="mdc-text-field__input"
                            name={descName}
                            id={descId}
                            defaultValue=""
                          />
                          <label
                            htmlFor={descId}
                            className="mdc-floating-label"
                          >
                            Description
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="pm-flex pm-flex-col">
                      <div className="mdc-form-field mdc-form-field--align-end">
                        <div
                          className="mdc-text-field pm-large"
                          data-mdc-auto-init="MDCTextField"
                        >
                          <input
                            type="number"
                            className="mdc-text-field__input"
                            name={qtyName}
                            id={qtyId}
                            defaultValue="1"
                          />
                          <label htmlFor={qtyId} className="mdc-floating-label">
                            Quantity
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="pm-flex pm-flex-col">
                      <div className="mdc-form-field mdc-form-field--align-end">
                        <div
                          className="mdc-text-field pm-large"
                          data-mdc-auto-init="MDCTextField"
                        >
                          <input
                            type="text"
                            className="mdc-text-field__input pm-format-money"
                            name={amountName}
                            id={amountId}
                            defaultValue={defaultAmount}
                          />
                          <label
                            htmlFor={amountId}
                            className="mdc-floating-label"
                          >
                            Amount
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {items.length > 1 && (
                    <>
                      <button
                        type="button"
                        className="mdc-button mdc-button mdc-button-icon pm-text-color--red1 pm-removable-row--remove pm-hide-mobile"
                        onClick={() => onRemove(index)}
                      >
                        <i className="mdi mdi-close"></i>
                      </button>
                      <button
                        type="button"
                        className="pm-text-color--red1 pm-removable-row--remove pm-hide-desktop"
                        onClick={() => onRemove(index)}
                      >
                        Remove
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button
        type="button"
        id={newButtonId}
        className={classNames(
          'mdc-button',
          'pm-text-color--white',
          'pm-bg-color--green1',
          {
            [newLeaseModalStyles.securityDepositNewItem]:
              newButtonId === 'new-security-deposit-item',
          }
        )}
        data-mdc-auto-init="MDCRipple"
        onClick={onAdd}
      >
        New Item
      </button>
    </>
  );
}
